import Pic from "assets/png/hero.png";

const Hero = () => {
  return (
    <section className="relative text-black py-20 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center justify-between">
        <div className="md:w-1/2 text-center md:text-left space-y-12">
          <h1 className="text-4xl md:text-5xl font-bold text-blue-100">
            <span className="text-gray-400">Smarter Security Solutions</span>{" "}
            for a Safer Tomorrow
          </h1>

          <p className="text-lg text-black">
            At Noble Guard Security Group, we don’t just follow trends — we lead
            them. Through Noble Secure Technologies, we deliver advanced
            security technology solutions designed to protect businesses, homes,
            and communities. From smart surveillance cameras to automated access
            control systems, we combine innovation with trust to give you total
            peace of mind. Secure your world with technology you can trust
          </p>

          <div className="">
            <a
              href="#services"
              className="bg-blue-600 hover:bg-blue-700 text-white font-semibold py-4 px-6 rounded-lg transition duration-300"
            >
              Explore Our Services
            </a>
          </div>
        </div>

        <div className="md:w-1/2 mt-10 md:mt-0 flex justify-center">
          <img
            src={Pic}
            alt="Security Technology"
            className="rounded-lg w-full max-w-md mix-blend-color-dodge"
          />
        </div>
      </div>
    </section>
  );
};

export default Hero;
